import React, { useEffect, useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
type PlanKey = 'basico' | 'completo';
const PLANS: {
  key: PlanKey;
  emoji: string;
  name: string;
  subtitle: string;
  items: string[];
  extraItems?: string[];
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  badge?: string;
  saveBadge?: string;
  isVip?: boolean;
}[] = [{
  key: 'basico',
  emoji: '💙',
  name: 'MEGAPACK MI ESPACIO INTERIOR',
  subtitle: '6 Tomos + 6 Bonos',
  items: ['📘 Tomo 1 — El Espejo', '📙 Tomo 2 — El Volcán', '📗 Tomo 3 — El Escudo', '📕 Tomo 4 — El Timón', '📓 Tomo 5 — El Puente', '📔 Tomo 6 — El Mapa'],
  oldPrice: '$65 USD',
  price: '$12.97',
  checkoutUrl: 'https://recursopack.com/cart/40978751914033:1'
}, {
  key: 'completo',
  emoji: '🏆',
  name: 'MEGAPACK + MASTER-PACK',
  subtitle: '6 Tomos + 6 Bonos + Sistema Completo de Implementación',
  items: ['📘 Tomo 1 — El Espejo', '📙 Tomo 2 — El Volcán', '📗 Tomo 3 — El Escudo', '📕 Tomo 4 — El Timón', '📓 Tomo 5 — El Puente', '📔 Tomo 6 — El Mapa'],
  extraItems: ['+ 🃏 30 Cartas de Conexión', '+ 🎲 Juego de las Emociones', '+ 📅 Plan de 30 días', '+ 🪙 Token System completo'],
  oldPrice: '$95 USD',
  price: '$16.97',
  checkoutUrl: 'https://recursopack.com/cart/40978752340017:1',
  badge: '⭐ Más elegido',
  saveBadge: 'Mejor valor',
  isVip: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState<PlanKey>('completo');
  const currentPlan = PLANS.find(p => p.key === selected)!;
  const fadeIn = useFadeIn();
  const [timeLeft, setTimeLeft] = useState(85408);
  useEffect(() => {
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-162">
          {/* Countdown Block */}
          <div className="text-center mb-12" data-id="element-163">
            <div className="inline-flex items-center gap-2 bg-purple-900/60 border border-purple-500/40 text-purple-300 font-bold text-sm md:text-base px-5 py-2 rounded-full mb-6" data-id="element-164">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-165" />
              <span data-id="element-166">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            </div>

            <div className="flex items-center justify-center gap-2 md:gap-3 mb-6" data-id="element-167">
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-168">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-169">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-170">
                  hs
                </div>
              </div>
              <span className="text-2xl md:text-4xl font-black text-purple-400" data-id="element-171">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-172">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-173">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-174">
                  min
                </div>
              </div>
              <span className="text-2xl md:text-4xl font-black text-purple-400" data-id="element-175">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-176">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-177">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-178">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-sm md:text-base mb-8" data-id="element-179">
              <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-180" />
              <span data-id="element-181">Después sube a su precio normal. No vuelve.</span>
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-182">
              <div className="flex items-center justify-between text-sm text-gray-400 mb-2" data-id="element-183">
                <span data-id="element-184">Cupos al precio de lanzamiento</span>
                <span className="font-bold text-yellow-400" data-id="element-185">Quedan pocos</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-186">
                <div className="h-full rounded-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                width: '82%'
              }} data-id="element-187"></div>
              </div>
              <p className="text-xs text-gray-500 mt-1.5 text-right" data-id="element-188">
                82% de los cupos ya tomados
              </p>
            </div>
          </div>

          {/* Pricing Header */}
          <div className="text-center mb-10" data-id="element-189">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-190">
              🛒 ELEGÍ TU MEGAPACK
            </h2>
            <p className="text-lg text-gray-400 font-medium" data-id="element-191">
              Descarga inmediata. Acceso de por vida. Las emociones no esperan.
            </p>
            <p className="text-white font-bold text-base md:text-lg mt-4 animate-bounce" data-id="element-192">
              👇 Elegí tu plan y dale a COMPRAR AHORA 👇
            </p>
            <p className="text-sm md:text-base text-yellow-400 font-bold mt-2" data-id="element-193">
              💳 Pagalo en tu moneda local
            </p>
          </div>

          <div className="space-y-3 mb-8" data-id="element-194">
            {PLANS.map(plan => {
            const isSelected = selected === plan.key;
            const isVip = plan.isVip;
            return <button key={plan.key} onClick={() => setSelected(plan.key)} className={`w-full rounded-2xl p-4 md:p-5 flex items-start gap-3 md:gap-4 transition-all duration-300 cursor-pointer text-left relative overflow-hidden ${isSelected ? isVip ? 'bg-gradient-to-br from-[#1a1a00] via-[#1a1500] to-[#1a1a00] border-2 border-yellow-400 shadow-[0_0_40px_rgba(250,204,21,0.25)]' : 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-60 hover:opacity-85'}`} data-id="element-195">
                  {isVip && isSelected && <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-196"></div>}
                  <div className={`w-5 h-5 mt-1 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${isSelected ? isVip ? 'border-yellow-400' : 'border-white' : 'border-gray-600'}`} data-id="element-197">
                    {isSelected && <div className={`w-2.5 h-2.5 rounded-full ${isVip ? 'bg-yellow-400' : 'bg-white'}`} data-id="element-198" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-199">
                    <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-200">
                      <span className="text-lg" data-id="element-201">{plan.emoji}</span>
                      <h3 className={`text-base md:text-lg font-black uppercase tracking-wide ${isVip ? 'text-yellow-400' : 'text-white'}`} data-id="element-202">
                        {plan.name}
                      </h3>
                    </div>

                    {(plan.badge || plan.saveBadge) && <div className="flex flex-wrap items-center gap-1.5 mb-1.5" data-id="element-203">
                        {plan.badge && <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-204">
                            {plan.badge}
                          </span>}
                        {plan.saveBadge && <span className="inline-flex items-center text-yellow-400 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full border border-yellow-400/50 uppercase tracking-wider bg-yellow-400/10" data-id="element-205">
                            {plan.saveBadge}
                          </span>}
                      </div>}

                    <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-206">
                      {plan.subtitle}
                    </p>

                    {isSelected && <div className="flex flex-col gap-0.5 mt-2" data-id="element-207">
                        {plan.items.map((item, i) => <p key={i} className="text-[11px] md:text-xs text-gray-400" data-id="element-208">
                            {item}
                          </p>)}
                        {plan.extraItems?.map((item, i) => <p key={`extra-${i}`} className={`text-xs md:text-sm font-bold ${isVip ? 'text-yellow-300' : 'text-blue-300'}`} data-id="element-209">
                            {item}
                          </p>)}
                      </div>}
                  </div>
                  <div className="text-right flex-shrink-0 pt-0.5" data-id="element-210">
                    <p className="text-[11px] md:text-sm text-gray-500 line-through font-medium" data-id="element-211">
                      {plan.oldPrice}
                    </p>
                    <p className={`text-2xl md:text-3xl font-black ${isVip && isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-212">
                      {plan.price}
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <p className="text-center text-sm md:text-base text-gray-300 italic mb-4" data-id="element-213">
            🔥 El 82% de las familias elige el MegaPack + Master-Pack. Es el que
            más resultados da.
          </p>
          <p className="text-center text-sm md:text-base text-yellow-400 font-bold mb-6" data-id="element-214">
            💳 Pagalo en tu moneda local
          </p>

          <a href={currentPlan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-215">
            <div className="relative w-full group cta-pulse" data-id="element-216">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl opacity-70 md:group-hover:opacity-100 transition duration-200" data-id="element-217"></div>
              <div className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide md:hover:from-red-400 md:hover:to-red-600 transition-all" data-id="element-218">
                <div className="flex items-center gap-2 text-center" data-id="element-219">
                  👉 COMPRAR AHORA
                </div>
                <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-220">
                  Descarga inmediata • Garantía de 7 días
                </span>
              </div>
            </div>
          </a>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-500 text-sm" data-id="element-221">
            <span className="flex items-center gap-1" data-id="element-222">🔒 Pago seguro</span>
            <span data-id="element-223">•</span>
            <span className="flex items-center gap-1" data-id="element-224">
              📥 Descarga inmediata
            </span>
            <span data-id="element-225">•</span>
            <span className="flex items-center gap-1" data-id="element-226">✅ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}